import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import NoInventoryDropdown from './NoInventoryDropdown'
import Tooltip from '../../../../../../../../../../../../components/Tooltip'
import TooltipTrigger from '../../../../../../../../../../../../components/Tooltip/TooltipTrigger'
import TooltipContent from '../../../../../../../../../../../../components/Tooltip/TooltipContent'
import CompetingQuotations from '../../../../../../../ProductsTable/cols/DatesCol/DatesCell/CompetingQuotations'

import useCompetingPeriods from '../../../../../../../ProductsTable/cols/DatesCol/DatesCell/Preview/useCompetingPeriods'

import { ReactComponent as AlertIcon } from '../../../../../../../../../../../../assets/icons/alertIcon.svg'

import { PRODUCT_PERIODS_DATES } from '../../../../../../../../fields'

import { greyOutline } from '../../../../../../../../../../../../styles/const/colors'

import useStyles from './styles'

const PeriodsValidationCell = ({ productValues, isValid }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const productData = productValues.data
  const isInventoryLoading = productValues.isInventoryLoading

  const selectedPeriods = productValues[PRODUCT_PERIODS_DATES]
  const hasCustomDates = selectedPeriods.some(period => period.isCustomDate)

  const { hasCompetingPeriods, competingPeriods } = useCompetingPeriods(productValues)

  if (isInventoryLoading) {
    return null
  }

  return (
    <div className={classes.periodsInfo}>
      {!isValid && <NoInventoryDropdown productValues={productValues} />}
      {hasCustomDates && (
        <Tooltip className={classes.tooltip}>
          <TooltipTrigger className={classes.tooltipTrigger}>
            <AlertIcon className={classes.customDates} />
          </TooltipTrigger>
          <TooltipContent borderColor={greyOutline}>
            <div className={classes.noPeriods}>{t('The selected dates are off-cycle for this product')}</div>
          </TooltipContent>
        </Tooltip>
      )}
      {hasCompetingPeriods && (
        <CompetingQuotations competingPeriods={competingPeriods} productPeriod={productData.period} />
      )}
    </div>
  )
}

PeriodsValidationCell.propTypes = {
  productValues: PropTypes.object
}

export default PeriodsValidationCell
